import React from 'react'
import './styles.css';

function ChooseUs() {
    return (
      <>
        <div className='chooseus'>
        <div className="title-text">
            <p>WHY CHOOSE US?</p>
        </div>
        <div className="about-box">
            <div className="single-about">
                <div className="overlay"></div>
                <div className="about-desc">
                    <h3>Expertise</h3>
                    <p>Our team comprises experienced software architects, developers, and engineers who stay at the forefront of technology trends.</p>
                </div>
            </div>
            <div className="single-about">
                <div className="overlay"></div>
                <div className="about-desc">
                    <h3>Customization</h3>
                    <p>We understand that one size does not fit all. Our software services are customized to meet your unique needs, ensuring that the solutions.</p>
                </div>
            </div>
            <div className="single-about">
                <div className="overlay"></div>
                <div className="about-desc">
                    <h3>Cutting Edge Technologies</h3>
                    <p>We embrace the latest technologies and methodologies to ensure that your software is not just up to date but future-proof.</p>
                </div>
            </div>
            <div className="single-about">
                <div className="overlay"></div>
                <div className="about-desc">
                    <h3>User-Centric Design</h3>
                    <p>Our user experience (UX) and user interface (UI) designers focus on creating software that not only functions flawlessly but is also a pleasure to use.</p>
                </div>
            </div>
            <div className="single-about">
                <div className="overlay"></div>
                <div className="about-desc">
                    <h3>Agile Development</h3>
                    <p>We follow Agile methods to deliver results quickly and adapt to changing requirements. You're always in the loop, with full flexibility.</p>
                </div>
            </div>
        </div>
    </div>
    </>
  );
}

export default ChooseUs;